import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Copy, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { api, PRODUCT_LABEL } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { PageHead, Stat } from "./parts";

export default function Overview() {
  const { user } = useAuth();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/me/stats").then(({ data }) => setS(data)).catch(() => {}); }, []);
  const shown = `${user.domain || "visc.lol"}/${user.username}`;
  const real = `${window.location.origin}/${user.username}`;
  const copy = () => { navigator.clipboard.writeText(real); toast.success("Link copied"); };
  return (
    <div>
      <PageHead eyebrow="overview" title={<>hey, <span className="grad-text">{user.display_name || user.username}</span></>} />
      <div className="panel noise relative mb-6 flex flex-wrap items-center justify-between gap-4 overflow-hidden p-6">
        <div className="absolute -left-10 top-0 h-32 w-60 bg-[#ff3b91]/10 blur-3xl" />
        <div className="relative">
          <div className="eyebrow">your page</div>
          <div className="mt-2 font-mono text-lg text-white" data-testid="overview-profile-url">{shown}</div>
        </div>
        <div className="relative flex gap-2">
          <button onClick={copy} className="btn-ghost" data-testid="overview-copy-link-button"><Copy className="h-4 w-4" /> copy</button>
          <a href={real} target="_blank" rel="noreferrer" className="btn-pink" data-testid="overview-open-profile-button">open <ArrowUpRight className="h-4 w-4" /></a>
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat label="profile views" value={(s?.views ?? user.views ?? 0).toLocaleString()} testid="stat-views" accent />
        <Stat label="links" value={s?.links ?? user.links.length} testid="stat-links" />
        <Stat label="hosted images" value={s?.images ?? 0} testid="stat-images" />
        <Stat label="plan" value={user.is_premium ? "premium" : "free"} testid="stat-plan" />
      </div>
      <div className="mt-6 grid gap-4 lg:grid-cols-2">
        <div className="panel p-6">
          <div className="eyebrow mb-4">owned upgrades</div>
          <div className="flex flex-wrap gap-2" data-testid="overview-owned-list">
            {(user.purchases || []).length === 0 && <span className="text-sm text-zinc-500">nothing yet.</span>}
            {(user.purchases || []).map((p) => <span key={p} className="rounded-full border border-[#ff3b91]/30 bg-[#ff3b91]/10 px-3 py-1 text-xs text-pink-100">{PRODUCT_LABEL[p] || p}</span>)}
          </div>
          <Link to="/dashboard/store" className="mt-6 inline-flex text-sm text-[#ff3b91] hover:underline" data-testid="overview-store-link">browse the store →</Link>
        </div>
        <div className="panel p-6">
          <div className="eyebrow mb-4">quick start</div>
          <ol className="space-y-3 text-sm text-zinc-400">
            {["upload an avatar & background", "write a bio that sounds like you", "add your socials", "share your link everywhere"].map((t, i) => (
              <li key={t} className="flex gap-3"><span className="font-mono text-[#ff3b91]">0{i + 1}</span>{t}</li>
            ))}
          </ol>
          <Link to="/dashboard/customize" className="btn-pink mt-6" data-testid="overview-customize-button">customize</Link>
        </div>
      </div>
    </div>
  );
}
